package uz.ferro.erp.feature.appuser.data

import uz.ferro.erp.api.suspendGet
import uz.ferro.erp.feature.appuser.model.SalesPointDto

object SalesPointRepository {
    suspend fun getSalesPoints() : List<SalesPointDto> {
        return suspendGet("/sales/points")
    }
}